const Bootstrap = require('./bootstrap');
const Dark = require('./dark');
const Default = require('./default');
const Flat = require('./flat');

module.exports = {
  Bootstrap,
  Dark,
  Default,
  Flat,
};
